import { useMemo, useState } from "react";

import Container from "@/layouts/container/Container";
import style from "./AllCourses.module.css";

import CourseCard from "@/features/courses/components/courseCard/CourseCard";
import CourseCategoryCards from "@/features/courses/components/courseCategoryCards/CourseCategoryCards";
import { useGetAllCourses } from "@/features/courses/hooks/useGetAllCourses";

import { useLocation } from "react-router-dom";

function countCategories(courses) {
	let res = {};
	for (const course of courses) {
		for (const category of course.categories) {
			if (!(category.slug in res)) {
				res[category.slug] = 0;
			}
			res[category.slug] += 1;
		}
	}
	return res;
}

function courseHasCategory(course, categorySlug) {
	return course.categories.some((category) => category.slug == categorySlug);
}

function categoriesWithCourseCounts(
	categories,
	courseCounts,
	semifilteredCourseCounts
) {
	return categories.map((category) => {
		return {
			...category,
			courseCount: courseCounts[category.slug] || 0,
			semifilteredCourseCount:
				semifilteredCourseCounts[category.slug] || 0,
			subcategories: category.subcategories.map((subcategory) => {
				return {
					...subcategory,
					courseCount: courseCounts[subcategory.slug] || 0,
					semifilteredCourseCount:
						semifilteredCourseCounts[subcategory.slug] || 0,
				};
			}),
		};
	});
}

function AllCourses() {
	const location = useLocation();
	const { courses, categories: rawCategories } = useGetAllCourses();

	const searchParams = new URLSearchParams(location.search);
	const initialCategory = searchParams.get("category");

	const [selectedCategory, setSelectedCategory] = useState(
		initialCategory || null
	);

	const filteredCourses = useMemo(() => {
		return courses
			.filter((course) => {
				if (selectedCategory)
					if (!courseHasCategory(course, selectedCategory))
						return false;

				return true;
			})
			.sort(
				(a, b) =>
					new Date(b.date_published) - new Date(a.date_published)
			);
	}, [courses, selectedCategory]);

	const categoryCourseCounts = useMemo(() => {
		return countCategories(courses);
	}, [courses]);

	const semifilteredCategoryCourseCounts = useMemo(() => {
		return countCategories(filteredCourses);
	}, [filteredCourses]);

	const categories = useMemo(() => {
		return categoriesWithCourseCounts(
			rawCategories,
			categoryCourseCounts,
			semifilteredCategoryCourseCounts
		);
	}, [categoryCourseCounts, semifilteredCategoryCourseCounts, rawCategories]);

	return (
		<section>
			<div className={style.header}>
				<div className={style.backgroundBar}>
					<Container>
						<div className={style.subHeader}>
							<div className={style.titleHolder}>
								<h2>Predmeti</h2>
								<span>({filteredCourses.length})</span>
							</div>
							<div className={style.cards}>
								<CourseCategoryCards
									categories={categories}
									selectedCategory={selectedCategory}
									setSelectedCategory={setSelectedCategory}
								/>
							</div>
						</div>
					</Container>
				</div>
			</div>
			<div className={style.body}>
				<div className={style.coursesHolder}>
					<div className={style.grid}>
						{filteredCourses.map((course) => (
							<CourseCard key={course.slug} course={course} />
						))}
					</div>
				</div>
			</div>
		</section>
	);
}

export default AllCourses;
